import { type Clip } from '@air/api/types';
import {
  CANVAS_ASSET_DROP_TYPE,
  CANVAS_ASSET_GRAB_OFFSET_TYPE,
  CANVAS_ASSET_IMPORT_SOURCE_TYPE,
  clipToCanvasAssetPayload,
} from '@air/feature-edit-canvas';

export type CanvasAssetGrabAnchor = { x: number; y: number };

export const setCanvasAssetDragData = ({
  dataTransfer,
  clips,
  grabAnchor,
  source = 'workspace',
}: {
  dataTransfer: DataTransfer;
  clips: Clip[];
  grabAnchor: CanvasAssetGrabAnchor;
  source?: 'workspace' | 'asset_picker';
}): void => {
  dataTransfer.setData(CANVAS_ASSET_DROP_TYPE, JSON.stringify(clips.map(clipToCanvasAssetPayload)));
  dataTransfer.effectAllowed = 'all';
  dataTransfer.setData(CANVAS_ASSET_GRAB_OFFSET_TYPE, JSON.stringify(grabAnchor));
  dataTransfer.setData(CANVAS_ASSET_IMPORT_SOURCE_TYPE, source);
};
